import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Typography, Box } from "@mui/material";

const CardWithActions = ({ backIcon, headerTitle, headerActions = [], children }) => {
  return (
    <Card
      sx={(theme) => ({
        border: `1px solid ${theme.palette.BudgieThemeColor.Neutrals[100]}`,
        borderRadius: "16px",
        boxShadow: `${theme.shadows[1]}`,
        padding: theme.spacing(2, 2),
        // Additional styles can be added here if needed
      })}
    >
      <CardContent
        sx={(theme) => ({
          padding: theme.spacing(0),
          // Additional styles for CardContent can be added here
        })}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2} // marginBottom
        >
          <Typography
            variant="h6"
            sx={(theme) => ({
              fontWeight: theme.typography.fontWeightBold,
              letterSpacing: theme.typography.h6.letterSpacing,
            })}
          >
            <Box display="flex" alignItems="center">
              {backIcon && backIcon}
              {headerTitle}
            </Box>
          </Typography>
          <Box display="flex" gap={1}>
            {headerActions.map((action, index) => (
              <Box key={index}>{action}</Box>
            ))}
          </Box>
        </Box>
        {children}
      </CardContent>
    </Card>
  );
};

export default CardWithActions;
